import * as React from "react";

interface IGuitarTabProps {
    app : any;
    config : any;
}

declare global {
    interface Window {
        songtive_debug: boolean;
        app : any;
        log(message : any);
    }
}

let arrays_equal = (a, b) => !!a && !!b && !(a < b || b < a);

//let offset = 12 * 3;
//let tune = [offset + 4, offset + 9, offset + 14, offset + 19, offset + 23, offset + 28];
let tune;

let notenames : any;

let dead_chord = [];

let strings : number;

let noteByApp = (app, struna) => (app + tune[struna]) % 12;

let getMinMaxNotes = function (canvas, notes) {
    let minnote = 24;
    let maxnote = 0;

    for (let i = 0, end = notes.length - 1, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
        if (notes[i] > 0 && notes[i] < minnote) {
            minnote = notes[i];
        }

        if (notes[i] > maxnote) {
            maxnote = notes[i];
        }
    }

    let chord_width = maxnote - minnote;

    minnote -= 4 - chord_width;

    if (minnote < 1) {
        minnote = 1;
    }

    return {
        min: minnote,
        max: maxnote
    };
};

class GuitarTab extends React.Component<IGuitarTabProps, any> {
    fret_width : number;
    fret_height : number;
    wdist : number;
    hdist : number;
    canvas : HTMLCanvasElement;

    constructor(props: IGuitarTabProps) {
        super(props);

        this.fret_width = 200;
        this.fret_height = 250;
        notenames = props.config.notenames;
        tune = props.config.tuning;
        strings = tune.length;
        for(var i = 0; i < strings; i++)
            dead_chord.push(-1);

        if (typeof document != "undefined") {
            this.canvas = document.createElement('canvas');
            this.canvas.width = this.fret_width * 2;
            this.canvas.height = this.fret_height * 2;
        }
        //canvas.hides = true;
        //canvas.print = true;

    }

    static getFinger(fingers, idx) : number {
        if (!fingers) {
            return null;
        }
        let r = fingers.indexOf(idx);
        if (r < 0) {
            return null;
        }
        return r + 1;
    }

    static getActualMinNote(notes) : number {
        let minNote = 24;
        for (let i = 0, end = notes.length - 1, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
            if (notes[i] > 0 && notes[i] < minNote) {
                minNote = notes[i];
            }
        }
        return minNote;
    }

    drawMinFret(ctx, minfret) {
        let fontSize : number;
        let y : number;
        if (strings < 6) {
            fontSize = this.wdist * 0.8;
            y = this.hdist * 2;
        } else {
            fontSize = this.wdist;
            y = this.hdist * 1.7;
        }
        ctx.fillStyle = "#006600";
        ctx.font = fontSize + "pt Verdana";
        ctx.fillText(`${ minfret }`, this.wdist * 0.8, y);
        ctx.fillStyle = "#000000";
    }

    drawX(ctx, x, y) {
        let fontSize : number;
        let offsetY;
        if (strings < 6) {
            fontSize = this.wdist;
            offsetY = this.hdist * 0.35;
        } else {
            fontSize = this.wdist * 1.1;
            offsetY = this.hdist * 0.25;
        }

        ctx.fillStyle = "#ff0000";
        ctx.font = fontSize + "pt Verdana";
        ctx.fillText("x", x + this.wdist * 0.6, y + offsetY);
        ctx.fillStyle = "#000000";
    }

    static getFingerFontSize(width) : number {
        if (strings < 6)
            return width / 2.5;
        else
            return width * 2 / 4;


    }

    drawChord(canvas, app) {
        let i;
        let asc, end;
        let notes = app.Notes;
        let mm = getMinMaxNotes(canvas, notes);

        let minfret = mm.min;
        let maxnote = mm.max;
        let actualMinNote = GuitarTab.getActualMinNote(notes);

        let chord_width = maxnote - minfret;

        let ctx = canvas.getContext("2d");
        let w = canvas.width;
        let h = canvas.height;

        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, w, h);

        if (canvas.hides && arrays_equal(dead_chord, notes)) {
            return; // dead chord
        }

        this.wdist = w / (strings + 2);
        this.hdist = h / 7;

        ctx.fillStyle = "#000000";
        ctx.drawStyle = "#000000";

        if (minfret > 1) {
            this.drawMinFret(ctx, minfret);
        }

        for (i = 0; i <= 5; i++) {
            ctx.lineWidth = 2;
            if (i === 0 && minfret <= 1) {
                ctx.lineWidth = 8;
            }

            ctx.beginPath();
            ctx.moveTo(this.wdist * 2, this.hdist * (i + 1));
            ctx.lineTo(this.wdist * (strings + 1), this.hdist * (i + 1));
            ctx.stroke();
        }

        let barreYPos = 0;
        let isBarreDrawn = false;

        for (i = 0, end = tune.length - 1, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
            ctx.beginPath();
            ctx.moveTo(this.wdist * (i + 2), this.hdist);
            ctx.lineTo(this.wdist * (i + 2), this.hdist * 6);
            ctx.stroke();

            let h_num = notes[i] - minfret + 1;
            if (notes[i] <= 0) {
                h_num = 0;
            }

            let circle_h = this.hdist * h_num; // преобразуем номер в координату
            circle_h += this.hdist / 2; // центрируем по ячейке

            if (!(app.HasBarre && notes[i] === actualMinNote)) {
                if (notes[i] === -1) {
                    this.drawX(ctx, this.wdist * (i + 1), circle_h);
                } else {
                    // draw filled circle with finger
                    ctx.beginPath();
                    let x = this.wdist * (i + 2);
                    let y = circle_h;
                    let isOpenString = notes[i] > 0;
                    let radius;
                    if (strings < 6)
                        radius = (this.wdist * 0.8) / 2;
                    else
                    {
                        if (isOpenString)
                            radius = this.wdist / 2;
                        else
                            radius = this.wdist / 2.5;
                    }


                    ctx.arc(x, y, radius, 0, Math.PI * 2, true);
                    ctx.closePath();
                    ctx.lineWidth = 6;
                    ctx.stroke();
                    ctx.lineWidth = 2;

                    if (isOpenString) {
                        ctx.fill();

                        ctx.font = GuitarTab.getFingerFontSize(this.wdist) + "pt Verdana";
                        ctx.fillStyle = "#ffffff";

                        let finger = GuitarTab.getFinger(app.Fingers, i);
                        ctx.fillText(finger, x - this.wdist * 0.2, y + this.hdist * 0.2);
                        ctx.fillStyle = "#000000";
                    }
                }
            } else if (app.HasBarre && !isBarreDrawn) {
                barreYPos = circle_h;
                isBarreDrawn = true;
            }

            ctx.fillStyle = "#000000";
            ctx.drawStyle = "#000000";
            ctx.font = this.wdist / 2.5 + "pt Verdana";

            // note names
            if (notes[i] >= 0) {
                let note = notenames[`${ noteByApp(notes[i], i) }`]
                if (note.length == 3)
                    ctx.font = this.wdist / 4.0 + "pt Verdana";
                if (note.length > 3)
                    ctx.font = this.wdist / 5.0 + "pt Verdana";

                ctx.fillText(note, this.wdist * (i + 1.7), this.hdist * 6.6);
            }

            ctx.beginPath();
            ctx.moveTo(this.wdist * 2, this.hdist * (i + 1));
            ctx.lineTo(this.wdist * (strings + 1), this.hdist * (i + 1));
            ctx.stroke();
        }

        // draw barre
        ctx.font = this.wdist / 2 + "pt Verdana";

        let barre_start = app.BarreStart;
        let barre_end = app.BarreEnd;

        if (app.HasBarre) {
            ctx.fillStyle = "#666666";
            ctx.drawStyle = "#000000";
            ctx.beginPath();
            ctx.rect(this.wdist * (Math.min(barre_start, barre_end) + 2), barreYPos - this.wdist / 2, this.wdist * Math.abs(barre_end - barre_start), this.wdist / 2 * 2);
            ctx.stroke();
            ctx.fill();
            ctx.fillStyle = "#000000";

            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(this.wdist * (barre_start + 2), barreYPos, this.wdist / 2, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(this.wdist * (barre_end + 2), barreYPos, this.wdist / 2, 0, Math.PI * 2, true);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();

            ctx.fillStyle = "#ffffff";
            ctx.fillText("1", this.wdist * (barre_start + 2) - this.wdist * 0.2, barreYPos + this.hdist * 0.2);
            ctx.fillStyle = "#000000";

            ctx.fillStyle = "#ffffff";
            ctx.fillText("1", this.wdist * (barre_end + 2) - this.wdist * 0.2, barreYPos + this.hdist * 0.2);
            return ctx.fillStyle = "#000000";
        }
    }

    prepareFingeringTxt() {
        let f = []
        let app = this.props.app

        for (let i = 0; i < app.Notes.length; i++)
            f[i] = ""

        if (app.HasBarre)
            for (let i = app.BarreStart; i < app.BarreEnd + 1; i++)
                f[i] = "1"

        for (let i = 0; i < app.Notes.length; i++)
            if (app.Notes[i] == -1)
                f[i] = 'x'
            else {
                let r = GuitarTab.getFinger(app.Fingers, i)
                if (r == null) {
                    if (!app.HasBarre)
                        f[i] = '.';
                } else
                    f[i] = r;
            }


        return f.join('')
    }

    render() {
        let img = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
        if (typeof window != "undefined") {
            this.drawChord(this.canvas, this.props.app);
            img = this.canvas.toDataURL("image/png");
        }

        let opts = {};


        let title = this.props.app.Notes.join(',').replace(/-1/g, 'x') + " (" + this.prepareFingeringTxt() + ")"

        if (typeof window != "undefined" && window.songtive_debug) {
            let notes_str = `Notes: ${ this.props.app.Notes.join(', ') }, Fingers: ${ this.props.app.Fingers.join(', ') } BareStart: ${this.props.app.BarreStart} BarreEnd: ${this.props.app.BarreEnd} `;

            opts["onClick"] = () => window.log(notes_str);
        }

        return <img src={img} title={title} alt={title} width={this.fret_width} height={this.fret_height} {...opts} />;
    }
}

export default GuitarTab;




// WEBPACK FOOTER //
// ./components/guitar/GuitarTab.tsx